import { type UseFormReturn } from "react-hook-form";
import { useOnMount } from "~/common/hooks/useOnMount";
import { getPersistedFormData, persistFormData } from "~/features/orders/common/utils/persistentFromData";
import { useEffect } from "react";

export const useLoadPersistedFormOnMount = (storageKey: string, reset: UseFormReturn<any>["reset"]) => {
  useOnMount(() => {
    reset(getPersistedFormData(sessionStorage, storageKey));
  });
};

export const useSavePersistedFormOnChange = (storageKey: string, getValues: UseFormReturn<any>["getValues"]) => {
  useEffect(() => {
    persistFormData(sessionStorage, storageKey, getValues());
  });
};
